// extracted by mini-css-extract-plugin
export default {"bar":"BarChart_bar__+u1JY","bars":"BarChart_bars__XOVcQ"};